import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { Grid } from "@material-ui/core";
import { fomMastikColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import cellEditFactory from "react-bootstrap-table2-editor";
import { read } from "Helpers/LocalStorage";
import { changeFomMastikSearch, disableFomMastik, EditPriceFomMastik, GetAllFomMastik } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function TblFomMastik() {
  const { t } = useTranslation();
  const { fomMastikData, fomMastikDataPagination, fomMastikDataSearch, rtlLayout } =
    useSelector((state) => ({
      fomMastikData: state.fomMastik.fomMastikData,
      fomMastikDataPagination: state.fomMastik.fomMastikDataPagination,
      fomMastikDataSearch: state.fomMastik.fomMastikDataSearch,
      rtlLayout: state.settings.rtlLayout,
    }));
  const [sizePerPage, setSizePerPage] = useState(fomMastikDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(fomMastikDataPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(fomMastikData);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (fomMastikData) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = fomMastikData?.IsG;
      const isUserHasAccessPrice2 = read("fomMasticRules").accessPrice2;
      const updateFomMastikColumn = [...fomMastikColumn];
      const isAllAdmin = fomMastikData.every((item) => item.IsG);
      updateFomMastikColumn[6].hidden = isAdmin || (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) || (isAllAdmin && isUserHasAccessPrice2 === false);
      updateFomMastikColumn[2].align = rtlLayout ? "right" : "left";
      updateFomMastikColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateFomMastikColumn);
    }
    return () => setColumns(null);
  }, [fomMastikData]);

  useEffect(() => {
    if (fomMastikData) {
      setTblData(fomMastikData);
      setTotal(fomMastikDataPagination.Total);
    }
  }, [fomMastikData, fomMastikDataPagination]);

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: Number(row.Id),
            Disable: updateNewValue,
          };
          await dispatch(disableFomMastik(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: fomMastikDataSearch?.Name,
            Limit: fomMastikDataPagination.Limit,
            Page: fomMastikDataPagination.Page,
          };
          await dispatch(GetAllFomMastik(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdFoamMastic: row.Id,
          };
          await dispatch(EditPriceFomMastik(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: fomMastikDataSearch?.Name,
            Limit: fomMastikDataPagination.Limit,
            Page: fomMastikDataPagination.Page,
          };
          await dispatch(GetAllFomMastik(params));
        } catch (err) {
      console.error('[catch error]', err)
    }
      } else {
        done(false);
      }
    }
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: sizePerPage,
          Page: page,
          Name: fomMastikDataSearch?.Name,
        };
        await dispatch(GetAllFomMastik(params));
        setLoading(false);
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const setValue = (name, value) => {
    dispatch(changeFomMastikSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
        Name: convertToEnglishNumber(fomMastikDataSearch.Name),
      };
      dispatch(GetAllFomMastik(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeFomMastikSearch({ Name: "" }));
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
      };
      dispatch(GetAllFomMastik(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="mb-1">
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={fomMastikDataSearch ? fomMastikDataSearch?.Name : ""}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_FomMastik" />}
        />
      )}
    </Fragment>
  );
}

export default TblFomMastik;
